import type { HoldPosition } from '@/types';

interface HoldPositionBadgeProps {
  value: HoldPosition | null | undefined;
}

const POSITION_CONFIG: Record<string, { label: string; className: string }> = {
  primary: { label: 'Primary', className: 'bg-[#EEE9F9] text-[#6B4FBB]' },
  secondary: { label: 'Secondary', className: 'bg-[#FEF3C7] text-[#92400E]' },
  tertiary: { label: 'Tertiary', className: 'bg-[#EFEFEF] text-[#555555]' },
};

const NOT_SET_CONFIG = { label: 'Not Set', className: 'bg-[#EFEFEF] text-[#555555]' };

export function HoldPositionBadge({ value }: HoldPositionBadgeProps) {
  const config = (value && POSITION_CONFIG[value]) || NOT_SET_CONFIG;

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
}
